import React, { useState, useEffect } from "react";
import { Field, Formik } from "formik";
import {
  CardHeaderToolbar,
  Input,
  Select
} from "../../../../../../_metronic/_partials/controls";
import * as Yup from "yup";
import "react-datepicker/dist/react-datepicker.css";
import {
  Tooltip,
  IconButton,
  Typography,
  FormControlLabel,
  Checkbox
} from "@material-ui/core";
import HelpIcon from "@material-ui/icons/Help";
import FormGroup from "@material-ui/core/FormGroup";
import {
  SUPERADMIN_SUBJECT_ROLE,
  SUPERADMIN_TITLE_ROLE
} from "../../../../../config/helper";
import { copyValue } from "../../../../../../_metronic/_helpers";

const validationSchema = Yup.object({
  name: Yup.string().required("Nama tidak boleh kosong!")
});

export default function AccessRoleEditForm({
  onSubmit,
  roleMaster,
  accessRole = {}
}) {
  const [access, setAccess] = useState([]);

  useEffect(() => {
    if (accessRole && accessRole.access) {
      setAccess(accessRole.access);
    }
  }, [accessRole]);

  const handleChangeRole = value => event => {
    if (event.target.checked === true) {
      let findDuplicate = access.findIndex(
        element =>
          element.subject === value.subject && element.action === value.action
      );
      if (findDuplicate <= 0) {
        setAccess([...access, value]);
      }
    } else {
      let findDuplicate = access.findIndex(
        element =>
          element.subject === value.subject && element.action === value.action
      );
      let newAccess = [...access];
      newAccess.splice(findDuplicate, 1);
      setAccess(newAccess);
    }
  };

  const checkedRoleFuction = value => {
    let checked = access.find(
      element =>
        element.action === value.action && element.subject === value.subject
    );
    if (checked) return true;
    else return false;
  };

  const accessRoleFunction = () => {
    let data = [];

    for (const key in roleMaster) {
      const valueInKey = [];
      const replaceKey = key => {
        return SUPERADMIN_TITLE_ROLE[key] ?? key;
      };
      for (const item of roleMaster[key]) {
        valueInKey.push(
          <FormControlLabel
            control={
              <Checkbox
                checked={checkedRoleFuction(item)}
                onChange={handleChangeRole(item)}
              />
            }
            label={
              SUPERADMIN_SUBJECT_ROLE[item.action.toLowerCase()] ?? item.action
            }
          />
        );
      }
      data.push(
        <tr>
          <td>
            <p className="text-dark font-weight-bolder text-hover-primary mb-1 font-size-lg">
              {replaceKey(key)}
            </p>
          </td>
          <FormGroup row>{valueInKey}</FormGroup>
        </tr>
      );
    }

    return data;
  };

  return (
    <Formik
      initialValues={accessRole}
      validationSchema={validationSchema}
      onSubmit={values => {
        let newValue = copyValue(values);
        newValue.access = access;
        onSubmit(newValue);
      }}
      enableReinitialize={true}
    >
      {({ setFieldValue, handleSubmit, values }) => (
        <>
          <div className="form-group">
            <div className="row">
              <div className="col-lg-4">
                <Field
                  name="name"
                  component={Input}
                  placeholder="Nama Role"
                  label="Nama"
                />
              </div>
            </div>
            <div className="mt-4 table-responsive">
              <table className="table table-borderless table-vertical-center">
                <tbody>{accessRoleFunction()}</tbody>
              </table>
            </div>
          </div>
          <button
            className="btn btn-primary float-right mx-1"
            onClick={handleSubmit}
          >
            Simpan
          </button>
        </>
      )}
    </Formik>
  );
}
